import { NgModule, SkipSelf, Optional } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { QRCodeWrapperModule } from '../shared/qrcode-wrapper.module';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../core/auth.guard';

import {
  ErrorComponent,
  ProfileComponent,
  SignInComponent,
  UsersComponent

} from '.';
function throwIfAlreadyLoaded(parentModule: any, moduleName: string) {
  if (parentModule) {
    throw new Error(`${moduleName} has already been loaded. Import Core modules in the AppModule only.`);
  }
}


const routes: Routes = [
  { path: 'signin', component: SignInComponent },
  { path: 'error', component: ErrorComponent },
  { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
  { path: 'users', component: UsersComponent, canActivate: [AuthGuard] },
];

const pages = [
  SignInComponent,
  ErrorComponent,
  ProfileComponent,
  UsersComponent
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    QRCodeWrapperModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    ...pages
  ],
  providers: []
})
export class MainModule { 
  constructor(@Optional() @SkipSelf() parentModule: MainModule) {
    if (parentModule) {
      throw new Error('Module is already loaded. Import in your base AppModule only.');
    }
  }
}
